import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './translations/en.json';
import tr from './translations/tr.json';
import de from './translations/de.json';
import fr from './translations/fr.json';
import es from './translations/es.json';
import pt from './translations/pt.json';
import kr from './translations/kr.json';
import cn from './translations/cn.json';
import jp from './translations/jp.json';

const resources = {
  en: { translation: en },
  tr: { translation: tr },
  de: { translation: de },
  fr: { translation: fr },
  es: { translation: es },
  pt: { translation: pt },
  kr: { translation: kr },
  cn: { translation: cn },
  jp: { translation: jp }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['cookie', 'localStorage', 'navigator'],
      lookupCookie: 'mentisra_language',
      caches: ['cookie', 'localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
